/* Jungle: blog search and category filter.
   131 articles and climbing - a paginated grid stops working long before the
   library stops growing. Loads a prebuilt index and filters client-side, so
   typing is instant. Falls back silently to the normal Shopify page if
   anything goes wrong. */
(function () {
  'use strict';
  var MOUNT = '.blog-posts-container';
  var host = document.querySelector(MOUNT);
  if (!host) return;

  var idxUrl = host.getAttribute('data-jbs-index') ||
    (window.JUNGLE_BLOG_INDEX || '');
  if (!idxUrl) return;

  fetch(idxUrl).then(function (r) { return r.json(); }).then(function (data) {
    if (!data || !data.articles || data.articles.length < 8) return;
    build(data.articles);
  }).catch(function () { /* leave the normal page alone */ });

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g,
      function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; });
  }

  function build(all) {
    var cats = [];
    all.forEach(function (a) { if (cats.indexOf(a.c) === -1) cats.push(a.c); });
    cats.sort();

    var wrap = document.createElement('div');
    wrap.className = 'jbs';
    wrap.innerHTML =
      '<div class="jbs__bar">' +
        '<input class="jbs__search" type="search" placeholder="Search ' + all.length +
          ' guides — try &quot;beret&quot;, &quot;returns&quot;, &quot;Gurkha&quot;" ' +
          'aria-label="Search guides">' +
      '</div>' +
      '<div class="jbs__cats"><button class="jbs__cat is-on" data-c="">All</button>' +
        cats.map(function (c) {
          return '<button class="jbs__cat" data-c="' + esc(c) + '">' + esc(c) + '</button>';
        }).join('') +
      '</div>' +
      '<p class="jbs__count"></p>' +
      '<div class="jbs__grid"></div>' +
      '<p class="jbs__none" hidden>Nothing matches that. Try a shorter word, or ' +
        '<button class="jbs__reset">show everything</button>.</p>';

    host.parentNode.insertBefore(wrap, host);
    host.style.display = 'none';               // hide the server-rendered grid

    var grid = wrap.querySelector('.jbs__grid');
    var count = wrap.querySelector('.jbs__count');
    var none = wrap.querySelector('.jbs__none');
    var search = wrap.querySelector('.jbs__search');
    var cat = '';
    var shown = 24;

    function matches() {
      var q = search.value.trim().toLowerCase();
      return all.filter(function (a) {
        if (cat && a.c !== cat) return false;
        if (!q) return true;
        return a.s.indexOf(q) !== -1;
      });
    }

    function render(reset) {
      if (reset) shown = 24;
      var list = matches();
      count.textContent = list.length + (list.length === 1 ? ' guide' : ' guides');
      none.hidden = list.length > 0;
      grid.innerHTML = list.slice(0, shown).map(function (a) {
        return '<a class="jbs__card" href="' + esc(a.u) + '">' +
          (a.i ? '<img src="' + esc(a.i) + '&width=600" alt="" loading="lazy">' : '<span class="jbs__noimg"></span>') +
          '<span class="jbs__cardcat">' + esc(a.c) + '</span>' +
          '<span class="jbs__title">' + esc(a.t) + '</span>' +
          (a.d ? '<span class="jbs__sum">' + esc(a.d) + '</span>' : '') +
          '</a>';
      }).join('');
      if (list.length > shown) {
        var more = document.createElement('button');
        more.className = 'jbs__more';
        more.textContent = 'Show more (' + (list.length - shown) + ' left)';
        more.onclick = function () { shown += 24; render(false); };
        grid.appendChild(more);
      }
    }

    var t;
    search.addEventListener('input', function () {
      clearTimeout(t); t = setTimeout(function () { render(true); }, 120);
    });
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('.jbs__cat');
      if (b) {
        cat = b.getAttribute('data-c');
        wrap.querySelectorAll('.jbs__cat').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        render(true);
        return;
      }
      if (e.target.closest('.jbs__reset')) {
        search.value = ''; cat = '';
        wrap.querySelectorAll('.jbs__cat').forEach(function (x, i) {
          x.classList.toggle('is-on', i === 0);
        });
        render(true);
      }
    });
    render(true);
  }
})();
